import React from 'react';

export default function Button({style, handleClick, type, title}) {

  return (
    <button
        className={`rounded text-sm px-4 lg:px-5 py-2 lg:py-2.5 ${style}`}
        onClick={handleClick}
        type={type}
      >
        {title}
      </button>
  );
}
